import { Button, Modal } from "react-bootstrap";
import { useState } from "react";
import styles from "./../Main.module.scss";
import CurrencyInput from "./CurrencyInput";
import { useDispatch } from "react-redux";
import { addCurrency } from "../../../redux/actions.portfolio";

const MainModal = ({ currency }) => {
  const dispatch = useDispatch();
  const [smShow, setSmShow] = useState(false);

  const [amount, setAmount] = useState("");

  const onAmountChange = (e) => {
    if (+e.target.value > -1 || e.target.value === "") {
      setAmount(e.target.value.trim());
    }
  };

  const addToPortfolio = () => {
    if (+amount > 0) {
      dispatch(addCurrency(currency, amount));
      setSmShow(false);
      setAmount("");
    }
  };

  return (
    <>
      <Button
        variant="info"
        onClick={() => setSmShow(true)}
        className={styles.paginationButton}
      >
        +
      </Button>{" "}
      <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            {currency.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CurrencyInput
            amount={amount}
            onAmountChange={onAmountChange}
            addToPortfolio={addToPortfolio}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MainModal;
